import React from 'react';

import {AutosuggestItem} from '@pb/kit-component-autosuggest-v2';
import {Group} from '@pb/kit-component-group';
import Loading from '@pb/kit-component-loading';

import type {AccountShortInfo} from 'src/openapi/admin/models/AccountShortInfo';
import type {ServerResponse} from 'src/typedef';

type Props = {
    busy: boolean,
    response: ServerResponse<Array<AccountShortInfo>> | null,
};

export const SearchAccountResult = ({busy, response}: Props) => {
    if (busy) {
        return (
            <div className="pd-s">
                <Group><Loading type="ICON"/> Loading</Group>
            </div>
        );
    }

    if (response?.data?.length) {
        return (
            <div>
                {response.data.map(account => (
                    <AutosuggestItem
                        key={account.accountId}
                        value={account}
                        caption={account.accountName}
                    />
                ))}
            </div>
        );
    }

    if (response?.data && !response.data.length) {
        return (
            <div className="pd-s">
                No accounts found
            </div>
        );
    }

    if (response?.error) {
        return (
            <div className="pd-s">
                {response.error.message}
            </div>
        );
    }

    return null;
};
